// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

.login-page {
  min-height: 100vh;
  background: #013868;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Logo */
.login-logo {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
}

.login-logo-mark {
  width: 64px;
  height: 64px;
  border-radius: 16px 16px 6px 16px;
  background: radial-gradient(circle at 10% 0%, #ffef9f 0, #f7b733 30%, #d4145a 80%);
  margin-right: 16px;
}

.login-logo-text {
  color: white;
  font-size: 45px;
  font-weight: 800;
  letter-spacing: .08em;
}

/* Card */
.login-card {
  background: white;
  width: 360px;
  max-width: 90vw;
  padding: 28px 32px;
  border-radius: 8px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, .35);
}

.login-title {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: 700;
}

.login-required {
  color: #e53935;
}

/* Inputs */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.login-input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 14px;
  outline: none;
}

.login-input:focus {
  border-color: #5325b6;
  box-shadow: 0 0 0 2px rgba(83, 37, 182, .15);
}

/* Password */
.login-password-wrapper {
  position: relative;
  margin-bottom: 15px;
}

.login-input-password {
  padding-right: 40px;
}

.login-password-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.login-password-icon {
  width: 20px;
  height: 20px;
  fill: #9e9e9e;
}

/* Extra */
.login-forgot {
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  color: #5a3bc6;
  cursor: pointer;
  align-self: flex-start;
}

.login-submit {
  padding: 10px;
  border-radius: 4px;
  border: none;
  background: #013868;
  color: white;
  font-weight: 600;
  cursor: pointer;
}

.login-logo-img {
  width: 170px;
  height: 80px;
  margin-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/web/component/Login/styles.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kFAAkF;EAClF,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["html,\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100%;\r\n}\r\n\r\n.login-page {\r\n  min-height: 100vh;\r\n  background: #013868;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Logo */\r\n.login-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.login-logo-mark {\r\n  width: 64px;\r\n  height: 64px;\r\n  border-radius: 16px 16px 6px 16px;\r\n  background: radial-gradient(circle at 10% 0%, #ffef9f 0, #f7b733 30%, #d4145a 80%);\r\n  margin-right: 16px;\r\n}\r\n\r\n.login-logo-text {\r\n  color: white;\r\n  font-size: 45px;\r\n  font-weight: 800;\r\n  letter-spacing: .08em;\r\n}\r\n\r\n/* Card */\r\n.login-card {\r\n  background: white;\r\n  width: 360px;\r\n  max-width: 90vw;\r\n  padding: 28px 32px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 18px 40px rgba(0, 0, 0, .35);\r\n}\r\n\r\n.login-title {\r\n  margin: 0 0 24px;\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n}\r\n\r\n.login-required {\r\n  color: #e53935;\r\n}\r\n\r\n/* Inputs */\r\n.login-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.login-input {\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ddd;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.login-input:focus {\r\n  border-color: #5325b6;\r\n  box-shadow: 0 0 0 2px rgba(83, 37, 182, .15);\r\n}\r\n\r\n/* Password */\r\n.login-password-wrapper {\r\n  position: relative;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.login-input-password {\r\n  padding-right: 40px;\r\n}\r\n\r\n.login-password-toggle {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-password-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  fill: #9e9e9e;\r\n}\r\n\r\n/* Extra */\r\n.login-forgot {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  font-size: 12px;\r\n  color: #5a3bc6;\r\n  cursor: pointer;\r\n  align-self: flex-start;\r\n}\r\n\r\n.login-submit {\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  border: none;\r\n  background: #013868;\r\n  color: white;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-logo-img {\r\n  width: 170px;\r\n  height: 80px;\r\n  margin-right: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
